import DeliveryService from "../DeliveryService"


const Stat = {
    formData(data) {
        let form = new FormData()
        for (let obj in data) {
            form.append(obj, data[obj])
        }
        return form
    },
    statMonth(params) {
        return DeliveryService.post(`/console/report/stat-month`)
    },
    statSale(data) {
        return DeliveryService.post(`/console/report/stat-sale`, data)
    },

}

export default Stat